import { Component, Input, OnInit } from '@angular/core';
import { CashPipe } from '../../shared/pipes/cash.pipe';

@Component({
    selector: 'app-promotion-leaderboard-my-rank',
    templateUrl: 'promotion-leaderboard-my-rank.component.html',
    styleUrls: ['promotion-leaderboard-my-rank.component.scss']
})
export class PromotionLeaderboardMyRankComponent implements OnInit {
    @Input() public myInfo: any;
    @Input() public isChase: any;
    @Input() public isWsopPrizeCustom: any;
    @Input() public prizeVisibility: boolean;
    @Input() public onlyCoin: boolean;
    @Input() public hideSymbol: boolean;
    @Input() public hideCustomSymbol: boolean;
    @Input() public nationalityName?: string;
    @Input() public isBountyKOPromotion?: boolean;
    private cashPipe = new CashPipe('en');

    constructor() {
    }

    public async ngOnInit() {

    }

    public wsopPrizeCustom(data) {
        let prize;
        const prizeITems = [];
        if (data.prizeItem) {
            data.prizeItem.map(item => {
                switch (item.currencyId) {
                    case 'GTD':
                        prizeITems.push(
                            this.cashPipe.transform(item.value, item.currencyId, 'symbol-narrow', '1.0-2')
                        );
                        break;
                    default:
                        const description = JSON.parse(item.description);
                        prizeITems.push(
                            `${description.name} x ${item.quantity}`
                        );
                        break;
                }
            });
            prize = `(${prizeITems.join('+')})`;
        }
        return prize;
    }
}
